<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre9" id="pgepubid00004">
      II
    </h2>
<p class="calibre7">
      The purchase of Evelina's clock had been a more important event in the
      life of Ann Eliza Bunner than her younger sister could divine. In the
      first place, there had been the demoralizing satisfaction of finding
      herself in possession of a sum of money which she need not put into the
      common fund, but could spend as she chose, without consulting Evelina, and
      then the excitement of her stealthy trips abroad, undertaken on the rare
      occasions when she could trump up a pretext for leaving the shop; since,
      as a rule, it was Evelina who took the bundles to the dyer's, and
      delivered the purchases of those among their customers who were too
      genteel to be seen carrying home a bonnet or a bundle of pinking—so
      that, had it not been for the excuse of having to see Mrs. Hawkins's
      teething baby, Ann Eliza would hardly have known what motive to allege for
      deserting her usual seat behind the counter.
    </p>
<p class="calibre7">
      The infrequency of her walks made them the chief events of her life. The
      mere act of going out from the monastic quiet of the shop into the tumult
      of the streets filled her with a subdued excitement which grew too intense
      for pleasure as she was swallowed by the engulfing roar of Broadway or
      Third Avenue, and began to do timid battle with their incessant
      cross-currents of humanity. After a glance or two into the great
      show-windows she usually allowed herself to be swept back into the shelter
      of a side-street, and finally regained her own roof in a state of
      breathless bewilderment and fatigue; but gradually, as her nerves were
      soothed by the familiar quiet of the little shop, and the click of
      Evelina's pinking-machine, certain sights and sounds would detach
      themselves from the torrent along which she had been swept, and she would
      devote the rest of the day to a mental reconstruction of the different
      episodes of her walk, till finally it took shape in her thought as a
      consecutive and highly-coloured experience, from which, for weeks
      afterwards, she would detach some fragmentary recollection in the course
      of her long dialogues with her sister.
    </p>
<p class="calibre7">
      But when, to the unwonted excitement of going out, was added the intenser
      interest of looking for a present for Evelina, Ann Eliza's agitation,
      sharpened by concealment, actually preyed upon her rest; and it was not
      till the present had been given, and she had unbosomed herself of the
      experiences connected with its purchase, that she could look back with
      anything like composure to that stirring moment of her life. From that day
      forward, however, she began to take a certain tranquil pleasure in
      thinking of Mr. Ramy's small shop, not unlike her own in its countrified
      obscurity, though the layer of dust which covered its counter and shelves
      made the comparison only superficially acceptable. Still, she did not
      judge the state of the shop severely, for Mr. Ramy had told her that he
      was alone in the world, and lone men, she was aware, did not know how to
      deal with dust. It gave her a good deal of occupation to wonder why he had
      never married, or if, on the other hand, he were a widower, and had lost
      all his dear little children; and she scarcely knew which alternative
      seemed to make him the more interesting. In either case, his life was
      assuredly a sad one; and she passed many hours in speculating on the
      manner in which he probably spent his evenings. She knew he lived at the
      back of his shop, for she had caught, on entering, a glimpse of a dingy
      room with a tumbled bed; and the pervading smell of cold fry suggested
      that he probably did his own cooking. She wondered if he did not often
      make his tea with water that had not boiled, and asked herself, almost
      jealously, who looked after the shop while he went to market. Then it
      occurred to her as likely that he bought his provisions at the same market
      as Evelina; and she was fascinated by the thought that he and her sister
      might constantly be meeting in total unconsciousness of the link between
      them. Whenever she reached this stage in her reflexions she lifted a
      furtive glance to the clock, whose loud staccato tick was becoming a part
      of her inmost being.
    </p>
<p class="calibre7">
      The seed sown by these long hours of meditation germinated at last in the
      secret wish to go to market some morning in Evelina's stead. As this
      purpose rose to the surface of Ann Eliza's thoughts she shrank back shyly
      from its contemplation. A plan so steeped in duplicity had never before
      taken shape in her crystalline soul. How was it possible for her to
      consider such a step? And, besides, (she did not possess sufficient logic
      to mark the downward trend of this “besides”), what excuse could she make
      that would not excite her sister's curiosity? From this second query it
      was an easy descent to the third: how soon could she manage to go?
    </p>
<p class="calibre7">
      It was Evelina herself, who furnished the necessary pretext by awaking
      with a sore throat on the day when she usually went to market. It was a
      Saturday, and as they always had their bit of steak on Sunday the
      expedition could not be postponed, and it seemed natural that Ann Eliza,
      as she tied an old stocking around Evelina's throat, should announce her
      intention of stepping round to the butcher's.
    </p>
<p class="calibre7">
      “Oh, Ann Eliza, they'll cheat you so,” her sister wailed.
    </p>
<p class="calibre7">
      Ann Eliza brushed aside the imputation with a smile, and a few minutes
      later, having set the room to rights, and cast a last glance at the shop,
      she was tying on her bonnet with fumbling haste.
    </p>
<p class="calibre7">
      The morning was damp and cold, with a sky full of sulky clouds that would
      not make room for the sun, but as yet dropped only an occasional
      snow-flake. In the early light the street looked its meanest and most
      neglected; but to Ann Eliza, never greatly troubled by any untidiness for
      which she was not responsible, it seemed to wear a singularly friendly
      aspect.
    </p>
<p class="calibre7">
      A few minutes' walk brought her to the market where Evelina made her
      purchases, and where, if he had any sense of topographical fitness, Mr.
      Ramy must also deal.
    </p>
<p class="calibre7">
      Ann Eliza, making her way through the outskirts of potato-barrels and
      flabby fish, found no one in the shop but the gory-aproned butcher who
      stood in the background cutting chops.
    </p>
<p class="calibre7">
      As she approached him across the tesselation of fish-scales, blood and
      saw-dust, he laid aside his cleaver and not unsympathetically asked:
      “Sister sick?”
     </p>
<p class="calibre7">
      “Oh, not very—jest a cold,” she answered, as guiltily as if
      Evelina's illness had been feigned. “We want a steak as usual, please—and
      my sister said you was to be sure to give me jest as good a cut as if it
      was her,” she added with child-like candour.
    </p>
<p class="calibre7">
      “Oh, that's all right.” The butcher picked up his weapon with a grin.
      “Your sister knows a cut as well as any of us,” he remarked.
    </p>
<p class="calibre7">
      In another moment, Ann Eliza reflected, the steak would be cut and wrapped
      up, and no choice left her but to turn her disappointed steps toward home.
      She was too shy to try to delay the butcher by such conversational arts as
      she possessed, but the approach of a deaf old lady in an antiquated bonnet
      and mantle gave her her opportunity.
    </p>
<p class="calibre7">
      “Wait on her first, please,” Ann Eliza whispered. “I ain't in any hurry.”
     </p>
<p class="calibre7">
      The butcher advanced to his new customer, and Ann Eliza, palpitating in
      the back of the shop, saw that the old lady's hesitations between liver
      and pork chops were likely to be indefinitely prolonged. They were still
      unresolved when she was interrupted by the entrance of a blowsy Irish girl
      with a basket on her arm. The newcomer caused a momentary diversion, and
      when she had departed the old lady, who was evidently as intolerant of
      interruption as a professional story-teller, insisted on returning to the
      beginning of her complicated order, and weighing anew, with an anxious
      appeal to the butcher's arbitration, the relative advantages of pork and
      liver. But even her hesitations, and the intrusion on them of two or three
      other customers, were of no avail, for Mr. Ramy was not among those who
      entered the shop; and at last Ann Eliza, ashamed of staying longer,
      reluctantly claimed her steak, and walked home through the thickening
      snow.
    </p>
<p class="calibre7">
      Even to her simple judgment the vanity of her hopes was plain, and in the
      clear light that disappointment turns upon our actions she wondered how
      she could have been foolish enough to suppose that, even if Mr. Ramy <i class="calibre16">did</i>
      go to that particular market, he would hit on the same day and hour as
      herself.
    </p>
<p class="calibre7">
      There followed a colourless week unmarked by farther incident. The old
      stocking cured Evelina's throat, and Mrs. Hawkins dropped in once or twice
      to talk of her baby's teeth; some new orders for pinking were received,
      and Evelina sold a bonnet to the lady with puffed sleeves. The lady with
      puffed sleeves—a resident of “the Square,” whose name they had never
      learned, because she always carried her own parcels home—was the
      most distinguished and interesting figure on their horizon. She was
      youngish, she was elegant (as the title they had given her implied), and
      she had a sweet sad smile about which they had woven many histories; but
      even the news of her return to town—it was her first apparition that
      year—failed to arouse Ann Eliza's interest. All the small daily
      happenings which had once sufficed to fill the hours now appeared to her
      in their deadly insignificance; and for the first time in her long years
      of drudgery she rebelled at the dullness of her life. With Evelina such
      fits of discontent were habitual and openly proclaimed, and Ann Eliza
      still excused them as one of the prerogatives of youth. Besides, Evelina
      had not been intended by Providence to pine in such a narrow life: in the
      original plan of things, she had been meant to marry and have a baby, to
      wear silk on Sundays, and take a leading part in a Church circle. Hitherto
      opportunity had played her false; and for all her superior aspirations and
      carefully crimped hair she had remained as obscure and unsought as Ann
      Eliza. But the elder sister, who had long since accepted her own fate, had
      never accepted Evelina's. Once a pleasant young man who taught in
      Sunday-school had paid the younger Miss Bunner a few shy visits. That was
      years since, and he had speedily vanished from their view. Whether he had
      carried with him any of Evelina's illusions, Ann Eliza had never
      discovered; but his attentions had clad her sister in a halo of exquisite
      possibilities.
    </p>
<p class="calibre7">
      Ann Eliza, in those days, had never dreamed of allowing herself the luxury
      of self-pity: it seemed as much a personal right of Evelina's as her
      elaborately crinkled hair. But now she began to transfer to herself a
      portion of the sympathy she had so long bestowed on Evelina. She had at
      last recognized her right to set up some lost opportunities of her own;
      and once that dangerous precedent established, they began to crowd upon
      her memory.
    </p>
<p class="calibre7">
      It was at this stage of Ann Eliza's transformation that Evelina, looking
      up one evening from her work, said suddenly: “My! She's stopped.”
     </p>
<p class="calibre7">
      Ann Eliza, raising her eyes from a brown merino seam, followed her
      sister's glance across the room. It was a Monday, and they always wound
      the clock on Sundays.
    </p>
<p class="calibre7">
      “Are you sure you wound her yesterday, Evelina?”
     </p>
<p class="calibre7">
      “Jest as sure as I live. She must be broke. I'll go and see.”
     </p>
<p class="calibre7">
      Evelina laid down the hat she was trimming, and took the clock from its
      shelf.
    </p>
<p class="calibre7">
      “There—I knew it! She's wound jest as <i class="calibre16">tight</i>—what you suppose's
      happened to her, Ann Eliza?”
     </p>
<p class="calibre7">
      “I dunno, I'm sure,” said the elder sister, wiping her spectacles before
      proceeding to a close examination of the clock.
    </p>
<p class="calibre7">
      With anxiously bent heads the two women shook and turned it, as though
      they were trying to revive a living thing; but it remained unresponsive to
      their touch, and at length Evelina laid it down with a sigh.
    </p>
<p class="calibre7">
      “Seems like somethin' <i class="calibre16">dead</i>, don't it, Ann Eliza? How still the room is!”
     </p>
<p class="calibre7">
      “Yes, ain't it?”
     </p>
<p class="calibre7">
      “Well, I'll put her back where she belongs,” Evelina continued, in the
      tone of one about to perform the last offices for the departed. “And I
      guess,” she added, “you'll have to step round to Mr. Ramy's to-morrow, and
      see if he can fix her.”
     </p>
<p class="calibre7">
      Ann Eliza's face burned. “I—yes, I guess I'll have to,” she
      stammered, stooping to pick up a spool of cotton which had rolled to the
      floor. A sudden heart-throb stretched the seams of her flat alpaca bosom,
      and a pulse leapt to life in each of her temples.
    </p>
<p class="calibre7">
      That night, long after Evelina slept, Ann Eliza lay awake in the
      unfamiliar silence, more acutely conscious of the nearness of the crippled
      clock than when it had volubly told out the minutes. The next morning she
      woke from a troubled dream of having carried it to Mr. Ramy's, and found
      that he and his shop had vanished; and all through the day's occupations
      the memory of this dream oppressed her.
    </p>
<p class="calibre7">
      It had been agreed that Ann Eliza should take the clock to be repaired as
      soon as they had dined; but while they were still at table a weak-eyed
      little girl in a black apron stabbed with innumerable pins burst in on
      them with the cry: “Oh, Miss Bunner, for mercy's sake! Miss Mellins has
      been took again.”
     </p>
<p class="calibre7">
      Miss Mellins was the dress-maker upstairs, and the weak-eyed child one of
      her youthful apprentices.
    </p>
<p class="calibre7">
      Ann Eliza started from her seat. “I'll come at once. Quick, Evelina, the
      cordial!”
     </p>
<p class="calibre7">
      By this euphemistic name the sisters designated a bottle of cherry brandy,
      the last of a dozen inherited from their grandmother, which they kept
      locked in their cupboard against such emergencies. A moment later, cordial
      in hand, Ann Eliza was hurrying upstairs behind the weak-eyed child.
    </p>
<p class="calibre7">
      Miss Mellins' “turn” was sufficiently serious to detain Ann Eliza for
      nearly two hours, and dusk had fallen when she took up the depleted bottle
      of cordial and descended again to the shop. It was empty, as usual, and
      Evelina sat at her pinking-machine in the back room. Ann Eliza was still
      agitated by her efforts to restore the dress-maker, but in spite of her
      preoccupation she was struck, as soon as she entered, by the loud tick of
      the clock, which still stood on the shelf where she had left it.
    </p>
<p class="calibre7">
      “Why, she's going!” she gasped, before Evelina could question her about
      Miss Mellins. “Did she start up again by herself?”
     </p>
<p class="calibre7">
      “Oh, no; but I couldn't stand not knowing what time it was, I've got so
      accustomed to having her round; and just after you went upstairs Mrs.
      Hawkins dropped in, so I asked her to tend the store for a minute, and I
      clapped on my things and ran right round to Mr. Ramy's. It turned out
      there wasn't anything the matter with her—nothin' on'y a speck of
      dust in the works—and he fixed her for me in a minute and I brought
      her right back. Ain't it lovely to hear her going again? But tell me about
      Miss Mellins, quick!”
     </p>
<p class="calibre7">
      For a moment Ann Eliza found no words. Not till she learned that she had
      missed her chance did she understand how many hopes had hung upon it. Even
      now she did not know why she had wanted so much to see the clock-maker
      again.
    </p>
<p class="calibre7">
      “I s'pose it's because nothing's ever happened to me,” she thought, with a
      twinge of envy for the fate which gave Evelina every opportunity that came
      their way. “She had the Sunday-school teacher too,” Ann Eliza murmured to
      herself; but she was well-trained in the arts of renunciation, and after a
      scarcely perceptible pause she plunged into a detailed description of the
      dress-maker's “turn.”
     </p>
<p class="calibre7">
      Evelina, when her curiosity was roused, was an insatiable questioner, and
      it was supper-time before she had come to the end of her enquiries about
      Miss Mellins; but when the two sisters had seated themselves at their
      evening meal Ann Eliza at last found a chance to say: “So she on'y had a
      speck of dust in her.”
     </p>
<p class="calibre7">
      Evelina understood at once that the reference was not to Miss Mellins.
      “Yes—at least he thinks so,” she answered, helping herself as a
      matter of course to the first cup of tea.
    </p>
<p class="calibre7">
      “On'y to think!” murmured Ann Eliza.
    </p>
<p class="calibre7">
      “But he isn't <i class="calibre16">sure</i>,” Evelina continued, absently pushing the teapot toward
      her sister. “It may be something wrong with the—I forget what he
      called it. Anyhow, he said he'd call round and see, day after to-morrow,
      after supper.”
     </p>
<p class="calibre7">
      “Who said?” gasped Ann Eliza.
    </p>
<p class="calibre7">
      “Why, Mr. Ramy, of course. I think he's real nice, Ann Eliza. And I don't
      believe he's forty; but he <i class="calibre16">does</i> look sick. I guess he's pretty lonesome,
      all by himself in that store. He as much as told me so, and somehow”—Evelina
      paused and bridled—“I kinder thought that maybe his saying he'd call
      round about the clock was on'y just an excuse. He said it just as I was
      going out of the store. What you think, Ann Eliza?”
     </p>
<p class="calibre7">
      “Oh, I don't har'ly know.” To save herself, Ann Eliza could produce
      nothing warmer.
    </p>
<p class="calibre7">
      “Well, I don't pretend to be smarter than other folks,” said Evelina,
      putting a conscious hand to her hair, “but I guess Mr. Herman Ramy
      wouldn't be sorry to pass an evening here, 'stead of spending it all alone
      in that poky little place of his.”
     </p>
<p class="calibre7">
      Her self-consciousness irritated Ann Eliza.
    </p>
<p class="calibre7">
      “I guess he's got plenty of friends of his own,” she said, almost harshly.
    </p>
<p class="calibre7">
      “No, he ain't, either. He's got hardly any.”
     </p>
<p class="calibre7">
      “Did he tell you that too?” Even to her own ears there was a faint sneer
      in the interrogation.
    </p>
<p class="calibre7">
      “Yes, he did,” said Evelina, dropping her lids with a smile. “He seemed to
      be just crazy to talk to somebody—somebody agreeable, I mean. I
      think the man's unhappy, Ann Eliza.”
     </p>
<p class="calibre7">
      “So do I,” broke from the elder sister.
    </p>
<p class="calibre7">
      “He seems such an educated man, too. He was reading the paper when I went
      in. Ain't it sad to think of his being reduced to that little store, after
      being years at Tiff'ny's, and one of the head men in their
      clock-department?”
     </p>
<p class="calibre7">
      “He told you all that?”
     </p>
<p class="calibre7">
      “Why, yes. I think he'd a' told me everything ever happened to him if I'd
      had the time to stay and listen. I tell you he's dead lonely, Ann Eliza.”
     </p>
<p class="calibre7">
      “Yes,” said Ann Eliza.
    </p>
<p class="calibre7">
<a id="link2H_4_0004">
</a>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?82a50b98